import { parseUserTime } from '@cumu/shared';
import { loc_invalidTime } from '@cumu/strings';
import { HTMLValueElement } from '../forms/utilities';
import { addCustomValidator } from '../forms/validation';
import { getLocale } from '../locale';

const locale = getLocale();

addCustomValidator((input: HTMLValueElement, label: string) => {
  if (
    input instanceof HTMLInputElement &&
    input.type === 'text' &&
    input.value.length &&
    input.name.includes(':time')
  ) {
    const value = input.value.trim();
    if (value.length === 0) {
      return null;
    }
    const parsed = parseUserTime(value);
    if (!parsed) {
      return loc_invalidTime[locale](label);
    }
  }
  return null;
});
